export default {
  PAYMENT_GATEWAY: 'PaymentGateway',
  MAINTENANCE_TIME: 'MaintenanceTime'
} as const
